import { derived } from "svelte/store";
import { leadsStore } from "./leadsStore";
import { page } from "$app/state";
import type { OutboxMessage } from "$lib/types/campaigns-new";

export const outboxMessagesStore = derived(leadsStore, ($leadsStore): OutboxMessage[] => {
  return $leadsStore.selectedLeads
    .map((lead) => {
      return {
        id: lead.message.id,
        providerType: "email",
        subject: lead.message.title || "No Subject",
        message: lead.message.message || "",
        approved: lead.message.is_approved || false,
        campaignId: page.params.id,
        lead: {
          id: lead.leadId,
          leadId: lead.leadId,
          firstName: lead.firstName || "",
          lastName: lead.lastName || "",
          email: lead.email || "",
          companyName: lead.companyName || "",
          title: lead.title || "",
          domain: (lead.email || lead.message.lead_identifier || "").split("@")[1] || "",
          answers: lead.answers,
        },
        createdAt: lead.message.created_at,
        updatedAt: lead.message.updated_at,
        approvedAt: lead.message.is_approved ? lead.message.updated_at : undefined,
        metaPrompt: "",
      };
    })
    .filter((lead) => !!lead.message);
});
